import React, { useState } from "react";
import { useAuth } from "../Context/AuthContext";
import "../Styling/ProjectProgressDashboard.css";
import axios from "axios";
import { Base_URL } from "../url";
import { useEffect } from "react";

const ProjectProgressList = () => {
  const { user } = useAuth();

  const [filters, setFilters] = useState({
    type: "All",
    client: "",
    project: "",
    resource: "",
    fromDate: "",
    toDate: "",
    dueDate: "",
    dueStatus: "All",

    // ✅ NEW FILTERS
    changedFromDate: "",
    changedToDate: "",
    submittedBy: "",
  });

  const [tableData, setTableData] = useState([]);
  const [dropdownData, setDropdownData] = useState({
    clients: [],
    projects: [],
    types: [],
    resources: [] ,
    submittedBy: [],
  });

  

  const handleChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = async () => {
    try {
      // ✅ Remove empty / default values
      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          if (value === "" || value === null) return false;
          if (value === "All") return false;
          return true;
        })
      );
  
      const res = await axios.get(`${Base_URL}/ProjectProgress/list`, {
        params: {
          ...cleanedFilters,
          orgId: user?.organisationId,
        },
      });
  
      setTableData(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const handleClear = () => {
    setFilters({
      type: "All",
      client: "",
      project: "",
      resource: "",
      fromDate: "",
      toDate: "",
      dueDate: "",
      dueStatus: "All",
      changedFromDate: "",
      changedToDate: "",
      submittedBy: "",
    });
  
    setTableData([]);
  };

  const loadDropdowns = async () => {
    try {
      const res = await axios.get(`${Base_URL}/ProjectProgress/filters`);
  
      setDropdownData(res.data);
    } catch (err) {
      console.log("Dropdown API error:", err);
    }
  };

  useEffect(() => {
    if (user?.organisationId) {
      handleApply();
    }
  }, [user]); 

//   useEffect(() => {
//     if (user?.organisationId) {
//       handleApply();
//     }
//   }, [filters]);

  useEffect(() => {
    if (user.organisationId) {
      setFilters((prev) => ({
        ...prev,
        organisationId: user.organisationId,
      }));
    }
  }, [user]);

  useEffect(() => {
    const fetchDropdowns = async () => {
        try {
          const res = await axios.get(
            `${Base_URL}/ProjectProgress/dropdowns`,
            {
              params: {
                orgId: user?.organisationId,
              },
            }
          );
      
          setDropdownData({
            clients: res.data.clients || [],
            projects: res.data.projects || [],
            types: res.data.types || [],
            resources: res.data.resources || [] ,
            submittedBy: res.data.submittedBy || [] 
          });
        } catch (err) {
          console.error("Dropdown API error:", err);
        }
      };

    if (user.organisationId) {
      fetchDropdowns();
    }
  }, [user]);

  return (
    <div className="ppl-container">
      <h2 className="ppl-title">Project Progress List</h2>

      {/* ================= FILTERS ================= */}
      <div className="ppd-filter-box">
        {/* Org ID */}
        <div className="ppd-field">
          <label>Organisation ID</label>
          <input value={user.organisationId || ""} disabled />
        </div>

        {/* Type */}
        <div className="ppd-field">
          <label>Type</label>
          <select
  value={filters.type}
  onChange={(e) => handleChange("type", e.target.value)}
>
  <option value="All">All</option>

  {dropdownData.types.map((t, i) => (
    <option key={i} value={t}>
      {t}
    </option>
  ))}
</select>
        </div>

        {/* Client */}
        <div className="ppd-field">
          <label>Client</label>
          <select
  value={filters.client}
  onChange={(e) => handleChange("client", e.target.value)}
>
  <option value="">Select Client</option>

  {dropdownData.clients.map((c, i) => (
    <option key={i} value={c}>
      {c}
    </option>
  ))}
</select>
        </div>

        {/* Project */}
        <div className="ppd-field">
          <label>Project</label>
          <select
  value={filters.project}
  onChange={(e) => handleChange("project", e.target.value)}
>
  <option value="">Select Project</option>

  {dropdownData.projects.map((p, i) => (
    <option key={i} value={p}>
      {p}
    </option>
  ))}
</select>
        </div>

        {/* Resource */}
        <div className="ppd-field">
  <label>Resource</label>
  <select
    value={filters.resource}
    onChange={(e) => handleChange("resource", e.target.value)}
  >
    <option value="">Select Resource</option>

    {dropdownData.resources.map((r, i) => (
      <option key={i} value={r}>
        {r}
      </option>
    ))}
  </select>
</div>

        <div className="ppd-field">
          <label>Due Date</label>
          <input
            type="date"
            value={filters.dueDate}
            onChange={(e) => handleChange("dueDate", e.target.value)}
          />
        </div>

        <div className="ppd-field">
  <label>Submitted By</label>
  <select
    value={filters.submittedBy}
    onChange={(e) => handleChange("submittedBy", e.target.value)}
  >
    <option value="">Select Submitted By</option>

    {dropdownData.submittedBy.map((s, i) => (
      <option key={i} value={s}>
        {s}
      </option>
    ))}
  </select>
</div>

        <div className="ppd-field">
          <label>Due Status</label>
          <select
            value={filters.dueStatus}
            onChange={(e) => handleChange("dueStatus", e.target.value)}
          >
            <option value="All">Select Status</option>
            <option value="Overdue">Overdue</option>
            <option value="Due">Due Today</option>
            <option value="Upcoming">Upcoming (7 days)</option>
            <option value="NotDue">Not Due (&gt; 7 days)</option>
          </select>
        </div>

        <div className="ppd-date-row">
          <div className="ppd-field">
            <label>Created From Date</label>
            <input
              type="date"
              value={filters.fromDate}
              onChange={(e) => handleChange("fromDate", e.target.value)}
            />
          </div>

          <div className="ppd-field">
            <label>Created To Date</label>
            <input
              type="date"
              value={filters.toDate}
              onChange={(e) => handleChange("toDate", e.target.value)}
            />
          </div>
        </div>

        {/* ✅ Changed Date Row */}
        <div className="ppd-date-row">
          <div className="ppd-field">
            <label>Changed From Date</label>
            <input
              type="date"
              value={filters.changedFromDate}
              onChange={(e) => handleChange("changedFromDate", e.target.value)}
            />
          </div>

          <div className="ppd-field">
            <label>Changed To Date</label>
            <input
              type="date"
              value={filters.changedToDate}
              onChange={(e) => handleChange("changedToDate", e.target.value)}
            />
          </div>
        </div>

        <div className="ppd-buttons">
          <button className="apply-btn" onClick={handleApply}>
            Apply
          </button>
          <button className="clear-btn" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="ppl-table-container">
        <table className="ppl-table">
          <thead>
            <tr>
              <th>Org ID</th>
              <th>Org Name</th>
              <th>Client ID</th>
              <th>Client Name</th>
              <th>Project ID</th>
              <th>Project Name</th>
              <th>Resource</th>
              <th>Due Date</th>
              <th>Due Status</th>
              <th>Created On</th>
              <th>Charged On</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Ticket ID</th>
              <th>Type</th>
              <th>Submitted By</th>
              {/* <th>Task ID</th> */}
            </tr>
          </thead>

          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <tr key={index}>
                  <td>{row.orgId}</td>
                  <td>{row.orgName}</td>
                  <td>{row.clientId}</td>
                  <td>{row.clientName}</td>
                  <td>{row.projectId}</td>
                  <td>{row.projectName}</td>
                  <td>{row.resourceId}</td>
                  <td>
                    {row.dueDate
                      ? new Date(row.dueDate).toLocaleDateString()
                      : ""}
                  </td>
                  <td>{row.dueStatus}</td>

                  <td>
                    {row.createdOn
                      ? new Date(row.createdOn).toLocaleDateString()
                      : ""}
                  </td>
                  <td>
                    {row.chargedOn
                      ? new Date(row.chargedOn).toLocaleDateString()
                      : ""}
                  </td>
                  <td>{row.status}</td>
                  <td>{row.priority}</td>
                  <td>{row.ticketId}</td>
                  {/* <td>{row.taskId}</td> */}
                  <td>{row.type}</td>
                  <td>{row.submittedBy}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="16" className="no-data">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectProgressList;
